export { default } from "./Menu";

